import { Colors } from "@batmaid/design-tokens";
import * as React from "react";
import styled, { css } from "styled-components";

interface MessageProps {
  bold?: boolean;
  color?: keyof Colors;
  className?: string;
  children: string;
}

const CleaningStatusMessage = ({ bold = true, ...props }: MessageProps) => (
  <CleaningStatusMessageWrapper
    className={props.className}
    bold={bold}
    color={props.color}
  >
    {props.children}
  </CleaningStatusMessageWrapper>
);

const CleaningStatusMessageWrapper = styled.span<{
  bold?: boolean;
  color?: keyof Colors;
}>`
  font-weight: ${props => props.bold && props.theme.fonts.weights.bold};
  white-space: pre-line;

  ${props =>
    !!props.color &&
    css`
      color: ${props.theme.palette[props.color]};
    `}
`;

export { CleaningStatusMessage };
